export default "/images/wm-website.png";